import reduxConnector from 'root/src/shared/util/reduxConnector'

import modalTitleSelector from 'root/src/client/logic/modal/selectors/modalTitleSelector'
import modalTextSelector from 'root/src/client/logic/modal/selectors/modalTextSelector'
import modalModuleIdSelector from 'root/src/client/logic/modal/selectors/modalModuleIdSelector'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'
import rejectProject from 'root/src/client/logic/project/thunks/rejectProject'
import modalRecordIdSelector from 'root/src/client/logic/modal/selectors/modalRecordIdSelector'
import auditFollowCreator from 'root/src/client/logic/creatorData/thunks/auditFollowCreator'
import modalPropsSelector from 'root/src/client/logic/modal/selectors/modalPropsSelector'
import closeButtonActionSelector from 'root/src/client/logic/modal/selectors/closeButtonActionSelector'
import deleteCoupon from 'root/src/client/logic/coupon/thunks/deleteCoupon'
import getModalProps from 'root/src/client/logic/modal/thunks/getModalProps'
import addToClipBoard from 'root/src/client/logic/app/thunks/displayEventSuccessMessage'
import modalContentSelector from 'root/src/client/logic/modal/selectors/modalContentSelector'
import dropUploadKeys from 'root/src/client/logic/tableItem/thunks/dropUploadKeys'
import dropUploadCodes from 'root/src/client/logic/tableItem/thunks/dropUploadCodes'
import dropPlatinumHandler from 'root/src/client/logic/dropEvent/thunks/dropPlatinumHandler'
import updateProfile from 'root/src/client/logic/profile/thunks/updateProfile'
import setImagePosition from 'root/src/client/logic/profile/thunks/setImagePosition'
import profileSelector from 'root/src/client/logic/creatorData/selectors/profileSelector'
import currentRouteParams from 'root/src/client/logic/route/selectors/currentRouteParams'
import dropEvent from 'root/src/client/logic/dropEvent/selectors/dropEventSelector'
import modalSubmitForm from 'root/src/client/logic/modal/thunks/modalSubmitForm'
import recordClickAction from 'root/src/client/logic/api/thunks/recordClickAction'
import deleteAgencyAccountManager
	from 'root/src/client/logic/brandSettings/thunks/deleteAgencyAccountManager'
import backButtonActionSelector from 'root/src/client/logic/modal/selectors/backButtonActionSelector'
import login from 'root/src/client/logic/auth/thunks/login'
import modifyGamePlatforms from 'root/src/client/logic/creatorData/thunks/modifyGamePlatforms'
import gamePlatformsSelector from 'root/src/client/logic/app/selectors/gamePlatformsSelector'
import creatorDataSelector from 'root/src/client/logic/app/selectors/creatorDataSelector'
import addTermsAcceptedCampaign from 'root/src/client/logic/creatorData/thunks/addTermsAcceptedCampaign'
import accountDataSelector from 'root/src/client/logic/userData/selectors/accountDataSelector'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import setEmail from 'root/src/client/logic/auth/thunks/setEmail'
import createProjectDrop from 'root/src/client/logic/project/thunks/createProjectDrop'
import formFieldTypes from 'root/src/client/logic/form/selectors/formFieldTypes'
import formData from 'root/src/client/logic/form/selectors/formData'
import clearForm from 'root/src/client/logic/form/thunks/clearForm'
import { getUserDropEventLandingShortUrl } from 'root/src/client/logic/dropEvent/thunks/getUserDropEventLandingShortUrl'
import { onModalMount } from 'root/src/client/logic/modal/thunks/onModalMount'

export default reduxConnector(
	[
		['modalContent', modalContentSelector],
		['modalTitle', modalTitleSelector],
		['modalText', modalTextSelector],
		['modalModuleId', modalModuleIdSelector],
		['modalRecordId', modalRecordIdSelector],
		['modalProps', modalPropsSelector],
		['profile', profileSelector],
		['currentRouteParams', currentRouteParams],
		['dropEvent', dropEvent],
		['backButtonAction', backButtonActionSelector],
		['closeButtonAction', closeButtonActionSelector],
		['gamePlatforms', gamePlatformsSelector],
		['creatorData', creatorDataSelector],
		['accountData', accountDataSelector],
		['isMobileRes', isMobileResSelector],
		['formFieldTypes', formFieldTypes],
		['formData', formData],
	],
	[
		['onModalMount', onModalMount],
		['displayModal', displayModal],
		['setImagePosition', setImagePosition],
		['rejectProject', rejectProject],
		['updateProfile', updateProfile],
		['auditFollowCreator', auditFollowCreator],
		['deleteCoupon', deleteCoupon],
		['getModalProps', getModalProps],
		['addToClipBoard', addToClipBoard],
		['dropUploadKeys', dropUploadKeys],
		['dropUploadCodes', dropUploadCodes],
		['dropPlatinumHandler', dropPlatinumHandler],
		['login', login],
		['modalSubmitForm', modalSubmitForm],
		['deleteAgencyAccountManager', deleteAgencyAccountManager],
		['modifyGamePlatforms', modifyGamePlatforms],
		['recordClickAction', recordClickAction],
		['addTermsAcceptedCampaign', addTermsAcceptedCampaign],
		['apiRequest', apiRequest],
		['createProjectDrop', createProjectDrop],
		['apiRequest', apiRequest],
		['setEmail', setEmail],
		['clearForm', clearForm],
		['getUserDropEventLandingShortUrl', getUserDropEventLandingShortUrl],
	],
)
